<template>
  <EntityAccessTypeCardIcon v-if="type === 'card'" />
  <EntityAccessTypeFreeIcon v-else-if="type === 'free'" />
  <EntityAccessTypeTicketIcon v-else-if="type === 'purchase_tickets' || type === 'reserve_tickets'" />
  <span v-else />
</template>

<script>
export default {
  components: {
    EntityAccessTypeCardIcon: () => import('@/components/icons/EntityAccessTypeCardIcon.vue'),
    EntityAccessTypeFreeIcon: () => import('@/components/icons/EntityAccessTypeFreeIcon.vue'),
    EntityAccessTypeTicketIcon: () => import('@/components/icons/EntityAccessTypeTicketIcon.vue'),
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
};
</script>
